// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TicketStatusButtons_buttonContainer__okVpn"};